<template>
	<CHeader with-subheader>
		<CToggler
			in-header
			class="ml-3 d-lg-none"
			@click="$store.commit('sidebar/toggleSidebarMobile')"
		/>
		<CToggler
			in-header
			class="ml-3 d-md-down-none"
			@click="$store.commit('sidebar/toggleSidebarDesktop')"
		/>
		<h3 v-if="pageTitle" class="header-name">
			{{ pageTitle }}
		</h3>
		<CHeaderBrand class="mx-auto d-lg-none" to="/" />
		<CHeaderNav class="d-md-down-none mr-auto" />
		<CHeaderNav>
			<TheHeaderDropdownAccnt />
		</CHeaderNav>
		<CSubheader v-if="hasBreadcrumbs" class="breadcrump-wrapper px-3">
			<BaseBreadcrumb :breadcrumbs="breadcrumbs" />
		</CSubheader>
	</CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt.vue';

export default {
	name: 'TheHeader',

	components: {
		TheHeaderDropdownAccnt,
	},

	props: {
		breadcrumbs: {
			type: [Boolean, Array],
			default: false,
		},
		pageTitle: {
			type: String,
			default: '',
		},
	},

	computed: {
		hasBreadcrumbs() {
			return this.breadcrumbs.length > 0;
		},
	},
};
</script>
<style lang="scss" scoped>
.header-name {
	display: flex;
	align-items: center;
	margin: 0;
}
</style>
